export const iconFontAwesomeHouseholdHouseFire = (
	<i className="fa-solid fa-house-fire"></i>
);
